import { addCtaClickListener } from './ctaTracking';

// Delegates CTA-click tracking from the page's #main container. Previously the
// cta-listener pack ran this inline at the end of <body>; now that it loads from
// ua-tracking in <head>, defer to DOMContentLoaded and guard the lookup.
const initMainCtaTracking = () => {
  const main = document.querySelector('#main');
  if (main) {
    addCtaClickListener(main);
  }
};

document.addEventListener('DOMContentLoaded', initMainCtaTracking);

export { initMainCtaTracking };
